// extracted by mini-css-extract-plugin
module.exports = {"root":"ArrowLinkIcon_root__et8yC","arrowLinkIcon":"ArrowLinkIcon_arrowLinkIcon__7qMrQ","static":"ArrowLinkIcon_static___5l7K","isOpen":"ArrowLinkIcon_isOpen___Utn1"};